<div
  [ngClass]="
    isDialogBox
      ? 'card dialog-box'
      : 'rounded shadow justify-content-center mx-3 mt-4 container-size'
  "
>
  @if (isDialogBox) {
    <div class="card-header">
      <span>
        {{ editUser ? "" : "Add User" }}
      </span>
      <span class="float-end" (click)="onCloseDialogue('close')">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
  }

  <div>
    <!-- User Details -->
    @if (editUser) {
      @if (editUserDetails) {
        <!--edit display name and display contact numbe3r of the user along with subscontractor relation-->
        <form [formGroup]="userForm" #f="ngForm" [class.p-4]="!isDialogBox">
          <div class="row gy-3 gx-0">
            @if (!detailData?.prime_contractors?.length) {
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="checkDefault"
                  [checked]="showSubcontractor"
                  (change)="setUnsetSubContractor()"
                />
                <label class="form-check-label" for="checkDefault">
                  Is Subcontractor
                </label>
              </div>

              @if (showSubcontractor) {
                <ng-template
                  *ngTemplateOutlet="subContractorTemplate"
                ></ng-template>
              }
            }
            <div class="input-group">
              <div class="form-floating">
                <input
                  class="form-control"
                  type="text"
                  id="display_name"
                  formControlName="display_name"
                  autocomplete="off"
                  placeholder="Display Name"
                  autofocus
                />
                <label>Display Name</label>
              </div>
              @if (userForm.value.display_name) {
                <span
                  class="input-group-text"
                  (click)="clearField('display_name')"
                >
                  <i class="fa-solid fa-xmark"></i>
                </span>
              }
            </div>
            <div class="input-group">
              <div class="form-floating">
                <input
                  class="form-control"
                  type="tel"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  minlength="7"
                  maxlength="10"
                  (input)="mobileNumberCheck()"
                  id="contact_number"
                  formControlName="contact_number"
                  autocomplete="off"
                  placeholder="Contact Number"
                  autofocus
                  [class.is-invalid]="
                    userForm.controls['contact_number'].invalid &&
                    userForm.controls['contact_number'].touched
                  "
                />
                <label>Contact Number</label>
              </div>
              @if (userForm.value.contact_number) {
                <span
                  class="input-group-text"
                  (click)="clearField('contact_number')"
                >
                  <i class="fa-solid fa-xmark"></i>
                </span>
              }
            </div>
          </div>
          <div class="row row-cols-2 my-3">
            <div class="col">
              <button
                type="button"
                class="btn btn-lg btn-dark w-100"
                (click)="
                  editUserDetails = false;
                  selectedSubContractor = detailData?.sub_contractor || {}
                "
              >
                Cancel
              </button>
            </div>
            <div class="col">
              <button
                type="submit"
                [disabled]="!userForm.valid"
                class="btn btn-lg btn-primary w-100"
                (click)="updateUserDetails(); editUserDetails = false"
              >
                Update
              </button>
            </div>
          </div>
        </form>
      } @else {
        <div id="profile-card" class="d-flex flex-column gap-3 px-3 p-lg-3">
          <div id="top-section">
            <div class="d-flex flex-row gap-2 gap-lg-4 align-items-center">
              @if (detailData?.profile_image) {
                <div id="profile-picture" class="profile-image-circle">
                  <img
                    src="{{ detailData?.profile_image }}"
                    alt="User Profile Image"
                  />
                </div>
              }
              <div id="name-contact-details">
                <div id="details-section" class="mb-4">
                  <div class="d-flex flex-wrap gap-2 align-items-center">
                    @if (userFullName) {
                      <div class="fs-3 text-break">
                        {{ userFullName }}
                      </div>
                      @if (
                        !isUserOwner &&
                        !(
                          isUserAboveManager &&
                          userData?.subscriber?.subscriber_user_id ===
                            detailData?.id
                        ) &&
                        !detailData?.prime_contractors?.length
                      ) {
                        <div
                          data-bs-placement="top"
                          [attr.role]="isFreeAccessAccount ? '' : 'button'"
                          [attr.data-bs-toggle]="
                            isFreeAccessAccount ? null : 'tooltip'
                          "
                          [title]="
                            isFreeAccessAccount
                              ? ''
                              : 'Switch Permanent / Casual'
                          "
                          (click)="
                            isFreeAccessAccount
                              ? null
                              : updateUserAccessStatus()
                          "
                        >
                          @if (userAccessStatus == 1) {
                            <span>
                              <i
                                class="fa-solid fa-circle text-success fs-3"
                              ></i>
                            </span>
                          } @else {
                            <span>
                              <i
                                class="fa-regular fa-circle text-body fs-3"
                              ></i>
                            </span>
                          }
                        </div>
                      }
                    }
                    @if (!detailData?.is_registered) {
                      <span class="has-not-signed-up text-break"
                        >[USER HAS NEVER SIGNED-IN]</span
                      >
                    }
                  </div>

                  <div class="mb-2 text-break small">
                    <a
                      href="mailto:{{ detailData?.email }}"
                      class="text-decoration-none text-body"
                      >{{ detailData?.email }}</a
                    >
                  </div>

                  <div>
                    @if (detailData?.user_add_info?.contact_number) {
                      <div class="d-flex flex-row gap-1">
                        <div>
                          <a
                            class="text-decoration-none text-body fw-semibold"
                            href="tel:+{{
                              detailData?.user_add_info?.contact_number
                            }}"
                            >{{ detailData?.user_add_info?.contact_number }}</a
                          >
                        </div>
                        <div class="phone-badge">Preferred</div>
                      </div>
                    }
                    @if (detailData?.mobile_number) {
                      <div class="d-flex flex-row gap-1 my-2">
                        <div>
                          <a
                            class="text-decoration-none text-body"
                            href="tel:+{{ detailData?.mobile_number }}"
                            >{{ detailData?.mobile_number }}</a
                          >
                        </div>
                      </div>
                    }
                  </div>
                </div>

                @if (selectedSubContractor?.id) {
                  <div class="mb-4">
                    <dt>Subcontractor</dt>
                    <dd>
                      <span class="text-orange fw-medium">
                        {{ selectedSubContractor?.company_name }}
                      </span>
                      <span
                        class="edit-button ms-2"
                        (click)="
                          openTemplate(editContractorTemplate, 'subcontractor')
                        "
                      ></span>
                    </dd>
                  </div>
                }

                @if (fromUserPage && isAdmin) {
                  <div class="d-flex gap-2 flex-wrap">
                    <div
                      class="hover border small p-1 px-3 bg-primary text-white rounded fw-semibold"
                      role="button"
                      (click)="editUserDetailsFn()"
                    >
                      Edit
                    </div>

                    @if (!detailData?.prime_contractors?.length) {
                      <div
                        class="hover border small p-1 px-3 bg-success text-white rounded fw-semibold"
                        role="button"
                        (click)="showUserStats()"
                      >
                        <i class="fa-solid fa-chart-line"></i>
                        User Stats
                      </div>
                    }

                    @if (
                      !isUserOwner &&
                      !(
                        isUserAboveManager &&
                        userData?.subscriber?.subscriber_user_id ===
                          detailData?.id
                      )
                    ) {
                      <div
                        class="hover border small p-1 px-3 rounded fw-semibold"
                        role="button"
                        [ngClass]="
                          detailData?.is_active
                            ? 'bg-warning text-dark'
                            : 'bg-white border-success text-success'
                        "
                        (click)="disableOrEnableUser(detailData?.id)"
                      >
                        @if (detailData?.is_active) {
                          <span>
                            <i class="fa-solid fa-lock"></i>
                          </span>
                          Disable Access
                        } @else {
                          <span>
                            <i class="fa-solid fa-unlock"></i>
                          </span>
                          Enable Access
                        }
                      </div>
                      <div
                        class="hover border small p-1 px-3 bg-danger text-white rounded fw-semibold"
                        role="button"
                        (click)="deleteUserById(detailData)"
                      >
                        Delete User
                      </div>
                    }
                    @if (!detailData?.additional_info?.user_note) {
                      <div
                        class="hover border small p-1 px-3 border-primary text-primary bg-white rounded fw-semibold"
                        role="button"
                        (click)="
                          openTemplate(
                            userInformationTemplate,
                            'userInformation'
                          )
                        "
                      >
                        <span><i class="fa-solid fa-clipboard-list"></i></span>
                        User Notes
                      </div>
                    }
                    @if (!detailData?.prime_contractors?.length) {
                      <div
                        class="hover border small p-1 px-3 border-primary text-white bg-primary rounded fw-semibold"
                        role="button"
                        (click)="onCloseDialogue('user-creds')"
                      >
                        <span><i class="fa-regular fa-id-card"></i></span>
                        Compliances
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>

          @if (!detailData?.prime_contractors?.length) {
            <div id="bottom-section">
              <div>
                @if (isAdmin && fromUserPage) {
                  <dl>
                    <dt>Clock In/Out</dt>
                    <dd>
                      <div
                        class="form-check"
                        role="button"
                        (click)="
                          updateUser(
                            { id: detailData?.id },
                            { update_clock_in_out_status: 1 }
                          )
                        "
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          role="button"
                          [checked]="
                            !detailData?.additional_info?.disable_clock_in_out
                          "
                          id="requiresClockInOut"
                        />
                        Requires Clock In & Out
                        <label
                          for="requiresClockInOut"
                          class="form-check-label me-3"
                        ></label>
                      </div>
                    </dd>
                  </dl>

                  <dl id="user-groups">
                    <dt>Permissions</dt>
                    <div class="row row-cols-auto ms-1">
                      @for (grp of userGroupListData; track grp) {
                        <div
                          class="form-check"
                          role="button"
                          (click)="
                            grp?.disabled
                              ? null
                              : addRemoveGroup(
                                  grp?.id,
                                  grp?.selected ? 'remove' : 'add'
                                )
                          "
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            role="button"
                            [checked]="grp?.selected"
                            [disabled]="grp?.disabled"
                            id="{{ grp?.id }}"
                          />
                          {{ grp.name }}
                          <label
                            for="{{ grp?.id }}"
                            class="form-check-label me-3"
                          ></label>
                        </div>
                      }
                      <div
                        class="col text-decoration-underline small"
                        role="button"
                        (click)="showGroupInfo = !showGroupInfo"
                      >
                        {{ showGroupInfo ? "Hide" : "More Info" }}
                      </div>
                    </div>
                  </dl>
                  @if (showGroupInfo) {
                    <div class="m-2 p-2 border border-1 rounded small">
                      <div class="mb-3">
                        <dt>Guards</dt>
                        <div>
                          Update assigned jobs and perform checkpoint scans.
                        </div>
                      </div>
                      <div class="mb-3">
                        <dt>Dispatchers</dt>
                        <div>Create, update, and assign jobs to guards.</div>
                        <div>Create and update sites.</div>
                        <div>Acknowledge SOS alerts</div>
                        <div>Manage welfare checks.</div>
                      </div>
                      <div class="mb-3">
                        <dt>Managers</dt>
                        <div>
                          Access to all other features including reporting.
                        </div>
                        <div class="text-danger">
                          Cannot manage subscription.
                        </div>
                      </div>
                    </div>
                  }

                  <dl>
                    <dt>Tags</dt>

                    <div class="d-flex gap-3 flex-wrap">
                      @for (
                        jType of availableJobTypeListData;
                        track jType?.id
                      ) {
                        <div
                          class="form-check"
                          role="button"
                          (click)="
                            addRemoveTag(
                              detailData?.user_tag_data?.[jType?.id],
                              jType?.id,
                              detailData?.user_tag_data?.[jType?.id]
                                ? 'remove'
                                : 'add'
                            )
                          "
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            role="button"
                            [checked]="detailData?.user_tag_data?.[jType?.id]"
                            id="{{ jType?.id }}"
                          />
                          {{ jType?.name }}
                          <label
                            for="{{ jType?.id }}"
                            class="form-check-label me-3"
                          ></label>
                        </div>
                      }
                    </div>
                  </dl>

                  @if (isUserAboveManager) {
                    <dl>
                      <dt>Reports</dt>
                      <div class="form-check mb-2">
                        <span role="button">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            role="button"
                            (change)="changeDefaultReportRecipent()"
                            [checked]="detailData?.default_report_recipient"
                            id="reportRecipient"
                          />
                          <label
                            for="reportRecipient"
                            class="form-check-label"
                            role="button"
                          >
                            Add as a recipient for new sites</label
                          >
                        </span>
                      </div>

                      @if (detailData?.is_registered) {
                        <div class="d-flex gap-2">
                          <button
                            class="btn btn-sm btn-warning hover"
                            (click)="addRemoveReportRecipients('remove')"
                            [disabled]="
                              !reportsConfigured?.user_already_in_some_reports
                            "
                          >
                            Remove from all reports
                          </button>

                          <button
                            class="btn btn-sm btn-success hover"
                            (click)="addRemoveReportRecipients('add')"
                            [disabled]="reportsConfigured?.user_in_all_reports"
                          >
                            Add as recipient to all existing sites
                          </button>
                        </div>
                      }
                    </dl>
                  }

                  @if (isAdmin && !fromUserPage) {
                    <dl>
                      <dt>Permissions</dt>
                      @for (
                        grp of detailData?.user_group;
                        track grp;
                        let l = $last
                      ) {
                        <span
                          >{{ grp?.name }}
                          @if (!l) {
                            <span>, </span>
                          }
                        </span>
                      }
                    </dl>
                  }
                }
              </div>
              <div id="credentials">
                @if (detailData?.id) {
                  <div>
                    <gtapp-identification
                      showFrom="userDetailPage"
                      [userId]="detailData?.id"
                    ></gtapp-identification>
                  </div>
                }
              </div>

              @if (detailData?.additional_info?.user_note?.trim()) {
                <dl id="siteInformation">
                  <dt>
                    Notes
                    <span
                      class="ms-3 edit-button"
                      (click)="
                        openTemplate(userInformationTemplate, 'userInformation')
                      "
                    ></span>
                  </dt>
                  <dd class="gt-multi-line d-flex align-items-center">
                    {{ detailData?.additional_info?.user_note }}
                  </dd>
                </dl>
              }
            </div>
          } @else {
            <dl id="bottom-section">
              <dt>Prime Contractor Login</dt>
              <dd class="d-flex flex-column gap-2 overflow-25vh ps-2 my-2">
                @for (client of detailData?.prime_contractors; track $index) {
                  <div class="link-view" (click)="routeToClient(client)">
                    {{ client?.company_name }}
                  </div>
                }
              </dd>
            </dl>
          }
        </div>
      }
    } @else {
      <form [formGroup]="userForm" #f="ngForm">
        <div class="row gy-3 gx-0">
          @if (!isFreeAccessAccount) {
            <div
              class="btn-group"
              [ngClass]="isFreeAccessAccount ? 'd-none' : ''"
            >
              <button
                class="btn d-flex align-items-center justify-content-center gap-3"
                [disabled]="isFreeAccessAccount"
                [ngClass]="
                  userAccessStatus == 1 ? 'btn-success' : 'btn-outline-success'
                "
                (click)="userAccessStatus = 1; formatGroupList()"
              >
                Permanent
              </button>
              <button
                class="btn d-flex align-items-center justify-content-center gap-3"
                [ngClass]="
                  userAccessStatus === 2
                    ? 'btn-secondary'
                    : 'btn-outline-secondary bg-white'
                "
                (click)="userAccessStatus = 2; formatGroupList()"
              >
                Casual
              </button>
            </div>

            @if (userAccessStatus == 2 && !isNativeApp) {
              <div class="alert alert-secondary">
                <div class="mb-3">
                  Casual users will incur a fee of
                  <span class="fw-semibold">
                    ${{ perDayPerUserPrice }} per day, per user.</span
                  >
                </div>
                <div class="fw-semibold">
                  This <span class="text-danger"> only applies</span> if the
                  user has been assigned to a shift and/or has added any
                  updates.
                </div>
              </div>
            }
          }

          @if (permanentSlotsAvailable || userAccessStatus == 2) {
            <div id="subcontractor">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="checkDefault"
                  [checked]="showSubcontractor"
                  (change)="setUnsetSubContractor()"
                />
                <label class="form-check-label" for="checkDefault">
                  Is Subcontractor
                </label>
              </div>
              @if (showSubcontractor) {
                <ng-template
                  *ngTemplateOutlet="subContractorTemplate"
                ></ng-template>
              }
            </div>
            <div class="input-group">
              <div class="form-floating">
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  formControlName="email"
                  autocomplete="off"
                  placeholder="Enter email"
                  autofocus
                  autocapitalize="off"
                  [class.is-invalid]="
                    userForm.controls['email'].invalid &&
                    userForm.controls['email'].touched
                  "
                />
                <label for="email">Email</label>
              </div>
              @if (userForm.value.email) {
                <span class="input-group-text" (click)="clearField('email')">
                  <i class="fa-solid fa-xmark"></i>
                </span>
              }
            </div>
            <div class="row row-cols-2">
              <div class="col">
                <div class="input-group">
                  <div class="form-floating">
                    <input
                      class="form-control"
                      type="text"
                      id="first_name"
                      formControlName="first_name"
                      autocomplete="off"
                      placeholder="First Name"
                      (input)="updateDisplayName()"
                      autofocus
                      [class.is-invalid]="
                        userForm.controls['first_name'].invalid &&
                        userForm.controls['first_name'].touched
                      "
                    />
                    <label>First Name</label>
                  </div>
                  @if (userForm.value.first_name) {
                    <span
                      class="input-group-text"
                      (click)="clearField('first_name')"
                    >
                      <i class="fa-solid fa-xmark"></i>
                    </span>
                  }
                </div>
              </div>
              <div class="col">
                <div class="input-group">
                  <div class="form-floating">
                    <input
                      class="form-control"
                      type="text"
                      id="last_name"
                      formControlName="last_name"
                      autocomplete="off"
                      placeholder="Last Name"
                      (input)="updateDisplayName()"
                      autofocus
                      [class.is-invalid]="
                        userForm.controls['last_name'].invalid &&
                        userForm.controls['last_name'].touched
                      "
                    />
                    <label>Last Name</label>
                  </div>
                  @if (userForm.value.last_name) {
                    <span
                      class="input-group-text"
                      (click)="clearField('last_name')"
                    >
                      <i class="fa-solid fa-xmark"></i>
                    </span>
                  }
                </div>
              </div>
            </div>

            <div class="row row-cols-2">
              <div class="col">
                <div class="input-group">
                  <div class="form-floating">
                    <input
                      class="form-control"
                      type="text"
                      id="display_name"
                      formControlName="display_name"
                      autocomplete="off"
                      placeholder="Display Name"
                      autofocus
                    />
                    <label>Display Name</label>
                  </div>
                  @if (userForm.value.display_name) {
                    <span
                      class="input-group-text"
                      (click)="clearField('display_name')"
                    >
                      <i class="fa-solid fa-xmark"></i>
                    </span>
                  }
                </div>
              </div>
              <div class="col">
                <div class="input-group mb-3">
                  <div class="form-floating">
                    <input
                      class="form-control"
                      type="tel"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      minlength="7"
                      maxlength="10"
                      (input)="mobileNumberCheck()"
                      id="contact_number"
                      formControlName="contact_number"
                      autocomplete="off"
                      placeholder="Contact Number"
                      autofocus
                      [class.is-invalid]="
                        userForm.controls['contact_number'].invalid &&
                        userForm.controls['contact_number'].touched
                      "
                    />
                    <label>Contact Number</label>
                  </div>
                  @if (userForm.value.contact_number) {
                    <span
                      class="input-group-text"
                      (click)="clearField('contact_number')"
                    >
                      <i class="fa-solid fa-xmark"></i>
                    </span>
                  }
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="group_ids"> <dt>Permissions</dt></label>
              <div class="row row-cols-auto gap-3">
                @for (grp of userGroupListData; track grp) {
                  <div>
                    <label for="{{ grp?.id }}">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        [checked]="grp?.selected"
                        id="{{ grp?.id }}"
                        (change)="grp.selected = !grp?.selected"
                      />
                      {{ grp.name }}</label
                    >
                  </div>
                }
                <div
                  class="col text-decoration-underline small mx-auto my-3"
                  role="button"
                  (click)="showGroupInfo = !showGroupInfo"
                >
                  {{ showGroupInfo ? "Hide" : "More Info" }}
                </div>
              </div>
              @if (showGroupInfo) {
                <div class="m-2 p-2 border border-1 rounded small mb-3">
                  <div class="mb-3">
                    <dt>Guards</dt>
                    <div>
                      Update assigned jobs and perform checkpoint scans.
                    </div>
                  </div>
                  <div class="mb-3">
                    <dt>Dispatchers</dt>
                    <div>Create, update, and assign jobs to guards.</div>
                    <div>Create and update sites.</div>
                    <div>Acknowledge SOS alerts</div>
                    <div>Manage welfare checks.</div>
                  </div>
                  <div class="mb-3">
                    <dt>Managers</dt>
                    <div>Access to all other features including reporting.</div>
                    <div class="text-danger">Cannot manage subscription.</div>
                  </div>
                </div>
              }
            </div>

            <dl>
              <dt>Tags</dt>

              <div class="d-flex gap-3 flex-wrap">
                @for (jType of availableJobTypeListData; track jType?.id) {
                  <div class="form-check" role="button">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="button"
                      [checked]="jType?.selected"
                      (change)="jType.selected = !jType?.selected"
                      id="{{ jType?.id }}"
                    />
                    {{ jType?.name }}
                    <label
                      for="{{ jType?.id }}"
                      class="form-check-label me-3"
                    ></label>
                  </div>
                }
              </div>
            </dl>

            <div
              class="bg-primary-subtle text-dark border border-2 rounded fw-medium p-3"
            >
              New users will receive an email with instructions on how to sign
              in.
            </div>

            <div class="row row-cols-2">
              <div class="col">
                <button
                  type="button"
                  class="btn btn-lg btn-dark w-100"
                  (click)="onCloseDialogue('close')"
                >
                  Cancel
                </button>
              </div>
              <div class="col">
                <button
                  type="submit"
                  [disabled]="!userForm.valid"
                  class="btn btn-lg btn-primary w-100"
                  (click)="sendAddUserLink()"
                >
                  Submit
                </button>
              </div>
            </div>
          } @else {
            @if (isSubscriberAdmin) {
              <div
                class="p-3 d-flex justify-content-around align-items-center"
                (click)="addMoreUserSlots()"
              >
                Additional User Required
                <button
                  class="btn btn-outline-success bg-success-subtle fw-semibold"
                >
                  Purchase Additional User
                </button>
              </div>
            } @else {
              <div class="alert alert-warning">
                Unable to make user permanent, allocation exhausted.
              </div>
            }
          }
        </div>
      </form>
    }
  </div>
</div>

<ng-template #subContractorTemplate>
  @if (selectedSubContractor?.id) {
    <dl>
      <dt>Subcontractor</dt>
      <dd>
        <div class="d-flex gap-2 align-items-center">
          <div>
            {{ selectedSubContractor?.company_name }}
            @if (selectedSubContractor?.full_address) {
              <div class="small text-secondary">
                {{ selectedSubContractor?.full_address }}
              </div>
            }
          </div>
          <div (click)="selectedSubContractor = null">
            <i class="fa-solid fa-circle-minus fs-5 text-danger"></i>
          </div>
        </div>
      </dd>
    </dl>
  } @else {
    <gtapp-auto-complete
      [data]="subContractorLookupListData"
      placeHolder="Subcontractor"
      searchKeyword="company_name"
      [initialValue]="subContractorSearchString"
      [itemTemplate]="subContractorTemplate"
      [addInitialKey]="subContractorSearchString ? true : false"
      (inputChanged)="onContractorLookup($event)"
      (selected)="onContractorSelect($event)"
      inputId="contractorFieldId"
      [enableCloseOption]="true"
      (fieldCleared)="editField('contractors')"
    >
    </gtapp-auto-complete>
  }

  <ng-template #subContractorTemplate let-item>
    @if (item?.key === 0) {
      <div>ADD NEW SUBCONTRACTOR</div>
    } @else {
      <div class="fw-medium">
        {{ item?.company_name }}
      </div>
      @if (item?.full_address) {
        <div class="small text-secondary">
          {{ item?.full_address }}
        </div>
      }
    }
  </ng-template></ng-template
>
<ng-template #editContractorTemplate let-editContractorTemplate="dialogRef">
  <div class="card dialog-box">
    <div class="card-header">
      <span> Subcontractor </span>
      <span
        class="float-end"
        (click)="
          editContractorTemplate.close();
          selectedSubContractor = detailData?.sub_contractor || {}
        "
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <ng-template *ngTemplateOutlet="subContractorTemplate"></ng-template>
    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-lg btn-secondary w-100"
          (click)="editContractorTemplate.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          [disabled]="
            selectedSubContractor?.id == detailData?.sub_contractor?.id
          "
          type="submit"
          class="btn btn-lg btn-primary w-100"
          (click)="
            updateUser(
              {
                id: detailData?.id,
                sub_contractor_id: selectedSubContractor?.id,
              },
              { update_subcontractor: 1 }
            );
            editContractorTemplate.close()
          "
        >
          Save
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template
  #userInformationTemplate
  let-data
  let-userInformationTemplateRef="dialogRef"
>
  <div class="dialog-box card">
    <div class="card-header">
      User Notes
      <span class="float-end" (click)="userInformationTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="row">
      <div class="col">
        <textarea
          class="form-control"
          placeholder="Add notes here"
          cols="20"
          rows="20"
          wrap="hard"
          type="text"
          [maxlength]="4000"
          [(ngModel)]="data.newInfromation"
        ></textarea>
      </div>
    </div>

    <div class="row row-cols-2 mt-4">
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-dark"
          (click)="userInformationTemplateRef.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-primary"
          [disabled]="
            (data?.newInfromation?.length && !data?.newInfromation?.trim()) ||
            data?.newInfromation == data?.oldInfromation
          "
          (click)="
            userInformationTemplateRef.close();
            updateUser(
              {
                id: detailData?.id,
                note: data?.newInfromation,
              },
              { update_note: 1 }
            )
          "
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>
